<template>
  <el-dialog :title="'Нэмэлт ү/төлбөр'"
    :visible.sync="isShow"
    @close="mCloseFunction"
    @closed="mCloseFunction"
    :before-close="close"
    v-if="currentAdditionSalary"
    :close-on-click-modal="isOpenDialog"
    v-loading="settlementLoading"
    width="30%"
  >
    <el-form v-model="currentAdditionSalary">
    <el-form-item>
        <el-tag type="info">Жолооч: {{currentAdditionSalary.driver_name}}</el-tag>
      </el-form-item>
      <el-form-item label="Дүн">
        <el-input
          v-model="currentAdditionSalary.additional_amount"
          type="number"
          :rows="5"
        ></el-input>
      </el-form-item>
      <el-form-item label="Тайлбар">
        <el-input
          v-model="currentAdditionSalary.additional_note"
          type="textarea"
          :rows="5"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="mCloseFunction">Болих</el-button>
      <el-button
        :disabled="isDisable"
        type="success"
        @click="saveAdditional"
      >Хадгалах
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getGroups } from '@/utils/auth.js'
export default {
  name: 'SettlementDialog',
  props: {
    isShow: Boolean,
    closeAdditional: Function,
    currentAdditionSalary: Object,
    close: Function,
    saveAdditional: Function,
    formatPrice: Function,
    settlementLoading: Boolean
  },
  data () {
    return {
      isOpenDialog: false,
      group: [],
      isDisable: false
    }
  },
  created () {
    this.start()
  },
  methods: {
    async start () {
      this.group = await getGroups()
      if (this.group.includes('view')) this.isDisable = true
    },
    mCloseFunction () {
      this.closeAdditional()
    }
  }
}
</script>
